import useAlert from "@rf-hooks/useAlert";
import MxAlertMessage from "@rf-l1/alert/MxAlertMessage";
import { useErrorsFromMinimalFieldIa } from "./useErrorsFromMinimalFieldIa";

export const useValidateMinimalFieldRequired = () => {
  const { getErrors } = useErrorsFromMinimalFieldIa();
  const { warningAlert } = useAlert();
  const validateMinimalRequiredField = (): boolean => {
    const errors = getErrors();
    if (errors.length > 0) {
      warningAlert({
        title: "¡Atención!",
        message: (
          <>
            <MxAlertMessage>
              Asegúrese de completar todos los campos requeridos para usar la IA
              como:
              <br />
              <br />
              {errors.map(x => x.label).join(", ")}
            </MxAlertMessage>
          </>
        ),
        confirmBtnMessage: "Entendido"
      });
      return false;
    } else {
      return true;
    }
  };
  return {
    validateMinimalRequiredField
  };
};
